import { createFileRoute } from '@tanstack/react-router';

import { NotificationFormPage } from '@/features/notifications/NotificationFormPage';

function NotificationEditRoute() {
  const { notificationId } = Route.useParams();
  return <NotificationFormPage notificationId={notificationId} />;
}

export const Route = createFileRoute('/admin/_app/notifications/$notificationId/edit')({
  component: NotificationEditRoute,
});
